import { FC, Fragment } from 'react';
import { ListFilterDTO } from '@/features/filters/types/filters.dto';
import { CityProductsFilter } from '@/features/products/components/list/filters/localisationFilters/cityProductFilters';
import { VoivodeshipProductsFilter } from '@/features/products/components/list/filters/localisationFilters/voivodeshipProductFilters';
import { ProductPriceFilter } from '@/features/products/components/list/filters/priceFilter/productPriceFilter';
import { ProductFiltersAccordion } from '@/features/products/components/list/filters/productFiltersAccordion';

export const ProductFiltersItem: FC<{
  filter: ListFilterDTO;
  index: number;
  isMobile: boolean;
}> = ({ filter, index, isMobile }) => {
  const { title, items, code } = filter;

  return (
    <Fragment>
      {code === 'city' ? (
        <Fragment>
          <CityProductsFilter title={title} items={items} code={code} isMobile={isMobile} />
        </Fragment>
      ) : code === 'voivodeship' ? (
        <Fragment>
          <VoivodeshipProductsFilter title={title} items={items} code={code} isMobile={isMobile} />
        </Fragment>
      ) : (
        <ProductFiltersAccordion title={title} items={items} code={code} filter={filter} />
      )}

      {index === 1 && <ProductPriceFilter isMobile={isMobile} />}
    </Fragment>
  );
};
